<template>
  <div v-if="transformedRelatedProducts && transformedRelatedProducts.length">
    <ProductSliderContainer
      class="flex flex-col h-full"
      :products="transformedRelatedProducts"
      :loading="loading"
      :title="header"
      :see-all-link-text="linkText"
      :see-all-link-slug="linkUrl"
      :has-controls-outside-container="false"
      :is-product-zone="true"
      :is-full-width="true"
      :header-class="headerClass"
      :link-class="linkClass"
      :size="PRODUCT_CARD_SIZE.MINI"
      prev-arrow-class="-left-3.5"
      next-arrow-class="-right-3.5"
    />
  </div>
</template>

<script lang="ts">
import ProductSliderContainer from '~/components/organisms/Product/ProductSlider/ProductSliderContainer.vue';
import { getProductZoneFilter } from '~~/helpers/commercetools/graphql/getProductZoneFilter';
import { PRODUCT_ZONE_FILTER } from '~~/constants/productZone';
import type { ProductZoneFilter } from '~~/constants/productZone';
import { PRODUCT_CARD_SIZE } from '~~/constants/productCardSize';
import { transformProductsForNativeRouting } from '~~/helpers/routes/nativeRouting/transformProductsForNativeRouting';

export default defineComponent({
  name: 'ProductZoneBox',
  components: {
    ProductSliderContainer,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    linkText: {
      type: String,
      default: null,
    },
    linkUrl: {
      type: String,
      default: null,
    },
    linkClass: {
      type: String,
      default: 'text-EXPONDO-secondary',
    },
    productFilter: {
      type: String as PropType<ProductZoneFilter>,
      required: true,
      validator: (value: ProductZoneFilter) => {

        return Object.values(PRODUCT_ZONE_FILTER).includes(value);
      
      },
    },
  },
  setup(props) {

    const { languageAndCountry, countryCode } = useLocalization();
    const { productFilter } = toRefs(props);

    const {
      search: searchRelatedProducts,
      productsInStock: relatedProducts,
      loading,
    } = useProductRelated(`product-zone-${productFilter.value}`);

    const productCustomFilter = computed(() => {

      return getProductZoneFilter(productFilter.value, languageAndCountry.value, countryCode.value.toUpperCase());
    
    });
    const transformedRelatedProducts = computed(() =>
      transformProductsForNativeRouting(relatedProducts.value, countryCode.value),
    );

    useLazyAsyncData(`related-products-${productFilter.value}`, async () => {

      const searchParams = {
        limit: 8,
        customFilters: productCustomFilter.value,
      };
      await searchRelatedProducts(searchParams);

      return '';
    
    });

    return {
      transformedRelatedProducts,
      loading,
      PRODUCT_CARD_SIZE,
    };
  
  },
});

</script>
